import { C as d } from "./component-B88NZlIm.js";
import { T as c } from "./events-CnaEWcY_.js";
import { d as l } from "./utilities-D-QcnR4L.js";
class f extends d {
  #e;
  #n;
  #t;
  #i;
  connectedCallback() {
    (super.connectedCallback(),
      (this.#e = this.#h.bind(this)),
      (this.#n = this.#d.bind(this)),
      (this.#t = this.#c.bind(this)),
      (this.#i = this.#u.bind(this)),
      this.addEventListener("change", this.#e),
      document.addEventListener(c.variantUpdate, this.#n),
      document.addEventListener("input", this.#t),
      document.addEventListener("change", this.#t),
      document.addEventListener("click", this.#i, !0),
      queueMicrotask(() => this.#a()));
  }
  disconnectedCallback() {
    (this.removeEventListener("change", this.#e),
      document.removeEventListener(c.variantUpdate, this.#n),
      document.removeEventListener("input", this.#t),
      document.removeEventListener("change", this.#t),
      document.removeEventListener("click", this.#i, !0));
  }
  #a() {
    const i = document.getElementById(this.dataset.formId ?? "");
    if (!(i instanceof HTMLFormElement)) return;
    const t = i.elements.namedItem("quantity"),
      n = t instanceof RadioNodeList ? Array.from(t) : t instanceof HTMLInputElement ? [t] : [];
    for (const e of n)
      e instanceof HTMLInputElement && ((e.readOnly = !0), e.setAttribute("aria-readonly", "true"));
  }
  #r() {
    return Array.from(this.querySelectorAll("[data-tier]"))
      .map((i) => {
        if (!(i instanceof HTMLElement)) return null;
        const t = parseInt(i.dataset.amount ?? "0", 10) || 0,
          n = parseInt(i.dataset.qtyJump ?? "0", 10) || 0;
        return t > 0 ? { amount: t, qtyJump: n > 0 ? n : t } : null;
      })
      .filter(Boolean)
      .sort((i, t) => i.amount - t.amount);
  }
  #s(i, t) {
    const n = this.#r();
    if (n.length === 0) return 1;
    let e = -1;
    for (let a = 0; a < n.length; a++) n[a].amount <= i && (e = a);
    return e === -1 ? 1 : !t && i === n[e].amount ? (e > 0 ? n[e - 1].qtyJump : 1) : n[e].qtyJump;
  }
  #u(i) {
    const t = i.target;
    if (!(t instanceof Element)) return;
    const n = t.closest("[data-quantity-plus], [data-quantity-minus]");
    if (!(n instanceof HTMLElement)) return;
    const a =
      n.parentElement?.querySelector('input[name="quantity"], [data-quantity-input]') ?? null;
    if (!(a instanceof HTMLInputElement) || !this.#o(a)) return;
    const r = n.hasAttribute("data-quantity-plus"),
      o = parseInt(a.value, 10) || 0,
      m = parseInt(a.min, 10) || 1,
      s = this.#s(o, r),
      u = r ? o + s : o - s;
    if (u < m) {
      (i.stopImmediatePropagation(), i.preventDefault());
      return;
    }
    ((a.value = String(u)),
      a.dispatchEvent(new Event("input", { bubbles: !0 })),
      a.dispatchEvent(new Event("change", { bubbles: !0 })),
      i.stopImmediatePropagation(),
      i.preventDefault());
  }
  #c(i) {
    const t = i.target;
    if (!(t instanceof HTMLInputElement) || t.name !== "quantity" || !this.#o(t)) return;
    const n = parseInt(t.value, 10);
    this.#m(Number.isFinite(n) && n > 0 ? n : 0);
  }
  #o(i) {
    const t = this.dataset.formId ?? "";
    if (!t || i.form?.id === t || i.getAttribute("form") === t) return !0;
    const n = this.closest("[data-section-id]");
    return n instanceof HTMLElement && n.contains(i);
  }
  #m(i) {
    const t = Array.from(this.querySelectorAll("[data-tier]"))
      .map((e) => {
        if (!(e instanceof HTMLElement)) return null;
        const a = parseInt(e.dataset.amount ?? "0", 10) || 0,
          r = e.querySelector('input[type="radio"]');
        return a > 0 && r instanceof HTMLInputElement ? { amount: a, radio: r } : null;
      })
      .filter(Boolean)
      .sort((e, a) => e.amount - a.amount);
    let n = null;
    for (const e of t) e.amount <= i && (n = e);
    for (const e of t) e.radio.checked = e === n;
  }
  #d(i) {
    const t = i.detail;
    if (t?.data?.productId && String(t.data.productId) !== this.dataset.productId) return;
    const n = t?.data?.html;
    if (!n || typeof n.querySelector != "function") return;
    const e = n.querySelector("bulk-sale-selector");
    e instanceof HTMLElement
      ? ((this.innerHTML = e.innerHTML),
        (this.hidden = !1),
        queueMicrotask(() => {
          (this.#a(), this.#l());
        }))
      : ((this.innerHTML = ""), (this.hidden = !0), this.#f());
  }
  #l() {
    const i = document.getElementById(this.dataset.formId ?? "");
    if (!(i instanceof HTMLFormElement)) return;
    const t = i.elements.namedItem("quantity"),
      n = t instanceof RadioNodeList ? Array.from(t) : t instanceof HTMLInputElement ? [t] : [];
    for (const e of n)
      e instanceof HTMLInputElement &&
        ((e.value = "1"),
        e.dispatchEvent(new Event("input", { bubbles: !0 })),
        e.dispatchEvent(new Event("change", { bubbles: !0 })));
  }
  #f() {
    const i = document.getElementById(this.dataset.formId ?? "");
    if (!(i instanceof HTMLFormElement)) return;
    const t = i.elements.namedItem("quantity"),
      n = t instanceof RadioNodeList ? Array.from(t) : t instanceof HTMLInputElement ? [t] : [];
    for (const e of n)
      e instanceof HTMLInputElement && ((e.readOnly = !1), e.removeAttribute("aria-readonly"));
  }
  #h(i) {
    const t = i.target;
    if (!(t instanceof HTMLInputElement) || !t.dataset.amount) return;
    const n = document.getElementById(this.dataset.formId ?? "");
    if (!(n instanceof HTMLFormElement)) return;
    const e = t.dataset.amount,
      a = n.elements.namedItem("quantity"),
      r = a instanceof RadioNodeList ? Array.from(a) : a instanceof HTMLInputElement ? [a] : [];
    if (r.length === 0) {
      const o = document.createElement("input");
      ((o.type = "hidden"), (o.name = "quantity"), (o.value = e), n.appendChild(o));
      return;
    }
    for (const o of r)
      o instanceof HTMLInputElement &&
        ((o.value = e),
        o.dispatchEvent(new Event("input", { bubbles: !0 })),
        o.dispatchEvent(new Event("change", { bubbles: !0 })));
  }
}
l("bulk-sale-selector", f);
